<template>
  <div class="min-h-screen flex items-center justify-center p-4">
    <div class="w-full max-w-md bg-white rounded-lg shadow-xl p-8">
      <div class="text-center mb-8">
        <img src="@/assets/tnfd-logo.jpg" alt="TNFD Logo" class="w-24 h-24 object-contain mx-auto mb-3" />
        <h1 class="text-2xl font-bold text-green-800">Tamilnadu Forest Department</h1>
        <p class="text-gray-600 mt-1 text-sm">Animal Catching Operations System</p>
      </div>

      <form @submit.prevent="handleLogin" class="space-y-4">
        <div v-if="successMessage" class="p-3 bg-green-100 border border-green-400 text-green-700 rounded">
          {{ successMessage }}
        </div>

        <div v-if="error" class="p-3 bg-red-100 border border-red-400 text-red-700 rounded text-sm">
          <p class="font-semibold">⚠️ Login Error</p>
          <p>{{ error }}</p>
          <p v-if="isBackendDown" class="mt-2 text-xs text-yellow-700 bg-yellow-50 p-2 rounded">
            💡 Backend server not responding - using DEMO mode for testing
          </p>
        </div>

        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">Email</label>
          <input
            id="email"
            v-model="email"
            type="email"
            required
            class="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="admin@tnfd.actabc.org"
          />
        </div>

        <div>
          <label for="password" class="block text-sm font-medium text-gray-700">Password</label>
          <input
            id="password"
            v-model="password"
            type="password"
            required
            class="w-full mt-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="••••••••"
          />
        </div>

        <button
          type="submit"
          :disabled="loading"
          class="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ loading ? '⏳ Signing in...' : '🚀 Sign In' }}
        </button>
      </form>

      <div class="mt-6 p-4 bg-green-50 rounded-lg border border-green-200">
        <p class="text-xs text-gray-500 text-center">© Tamilnadu Forest Department · tnfd.actabc.org</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'

const email = ref('')
const password = ref('')
const loading = ref(false)
const error = ref(null)
const successMessage = ref(null)
const isBackendDown = ref(false)
const router = useRouter()
const authStore = useAuthStore()

const handleLogin = async () => {
  loading.value = true
  error.value = null
  successMessage.value = null
  isBackendDown.value = false

  try {
    const success = await authStore.login(email.value, password.value)
    if (success) {
      successMessage.value = '✅ Login successful! Redirecting...'
      setTimeout(() => {
        router.push('/')
      }, 1000)
    } else {
      // Check if it's a backend connectivity issue
      if (authStore.error?.includes('network') || authStore.error?.includes('timeout') || authStore.error?.includes('ERR_')) {
        isBackendDown.value = true
        error.value = 'Backend server not responding - using DEMO mode'
        // Still allow login in demo mode
        setTimeout(() => {
          router.push('/')
        }, 1500)
      } else {
        error.value = authStore.error || 'Login failed. Please check your credentials.'
      }
    }
  } catch (err) {
    console.error('Login error:', err)
    error.value = err.message || 'An unexpected error occurred'
  } finally {
    loading.value = false
  }
}
</script>
